// extracted by mini-css-extract-plugin
export default {"item-list":"SoftDrinksDesktop_item-list__pg769","item":"SoftDrinksDesktop_item__OVDlq","section":"SoftDrinksDesktop_section__hJ0ue"};